import { SessionRestControllerService, YearMonthsBreakdownResponse } from 'generated';
import { useCallback, useEffect, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

const useSessionYearBreakdown = () => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState<YearMonthsBreakdownResponse[]>();

  const fetchSessionYearBreakdown = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiWrapper(() =>
        SessionRestControllerService.getAllYearsMonthsBreakdownUsingGet(),
      );
      setLoading(false);
      setContent(data);
    } catch (error) {
      setLoading(false);
      setContent(undefined);
      handleError(error);
    }
  }, []);

  useEffect(() => {
    fetchSessionYearBreakdown();
  }, [fetchSessionYearBreakdown]);

  return {
    loading,
    fetchSessionYearBreakdown,
    sessionYearBreakdown: content,
  };
};

export default useSessionYearBreakdown;
